import { ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";

const HeroLogo = () => (
  <div className="flex flex-col items-center animate-fade-in">
    <div className="flex items-center gap-2 mb-6">
      <div className="w-12 h-[2px] bg-gradient-to-r from-transparent to-[#FF3B30]"></div>
      <div className="w-3 h-3 border-2 border-[#FF3B30] rotate-45"></div>
      <div className="w-12 h-[2px] bg-gradient-to-l from-transparent to-[#FF3B30]"></div>
    </div>
    <img src="/ttw-logo.png" alt="TTW Engineering" className="h-24 sm:h-32 lg:h-44 w-auto" data-testid="hero-logo" />
    <div className="flex items-center gap-3 mt-6">
      <div className="w-16 sm:w-24 h-[1px] bg-gradient-to-r from-transparent via-[#FF3B30] to-[#FF3B30]"></div>
      <span className="text-[#FF3B30] text-[10px] tracking-[0.4em] uppercase font-medium">Performance</span>
      <div className="w-16 sm:w-24 h-[1px] bg-gradient-to-l from-transparent via-[#FF3B30] to-[#FF3B30]"></div>
    </div>
  </div>
);

export default function HeroSection({ onShopClick }) {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-center justify-center hero-gradient">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(-45deg, transparent, transparent 10px, rgba(255,59,48,0.1) 10px, rgba(255,59,48,0.1) 11px)`
        }}></div>
      </div>
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <HeroLogo />
        <p className="mt-8 text-lg sm:text-xl text-[#8A8A8A] max-w-2xl mx-auto animate-fade-in-delay-1 font-light">
          Professionele Chiptuning & ECU Remapping in Lelystad
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm text-[#B0B0B0] animate-fade-in-delay-2">
          {["Chiptuning", "ECU Remapping", "Performance Parts", "Diagnostics"].map(t => (
            <span key={t} className="flex items-center gap-2">
              <span className="w-2 h-2 bg-[#FF3B30] rounded-full"></span>{t}
            </span>
          ))}
        </div>
        <p className="mt-4 text-xs text-[#6A6A6A] animate-fade-in-delay-2">
          Stage 1, 2 & 3 &middot; DPF &middot; EGR &middot; AdBlue &middot; Alle merken &middot; Lelystad &amp; omgeving
        </p>
        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-delay-3">
          <Button
            data-testid="hero-cta-button"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="btn-primary px-8 py-6 text-base font-semibold uppercase tracking-wider"
          >Get In Touch</Button>
          <Button
            data-testid="hero-shop-button"
            onClick={onShopClick}
            className="px-8 py-6 text-base font-semibold uppercase tracking-wider bg-transparent border-2 border-[#FF3B30] text-[#FF3B30] hover:bg-[#FF3B30] hover:text-white"
          ><ShoppingBag size={18} className="mr-2" />Shop</Button>
          <Button
            data-testid="hero-services-button"
            variant="outline"
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-6 text-base font-semibold uppercase tracking-wider border-[#2A2A2A] text-[#B0B0B0] hover:text-white hover:border-[#FF3B30] bg-transparent"
          >Our Services</Button>
        </div>

        {/* Dealer badges */}
        <div className="mt-10 flex flex-col items-center gap-3 animate-fade-in-delay-3" data-testid="hero-dealer-badges">
          <div className="flex items-center gap-3 bg-[#111]/60 backdrop-blur-sm border border-[#1E1E1E] rounded-xl px-5 py-3">
            <img src="/logos/wossner.png" alt="Wössner Pistons" className="h-8 w-auto" />
            <div className="text-left">
              <p className="text-white text-xs font-semibold">Wössner Forged Pistons &amp; Drijfstangen</p>
              <p className="text-[#888] text-[10px]">Officieel dealer — gesmede internals voor alle merken</p>
            </div>
          </div>
          <div className="flex items-center gap-3 bg-[#111]/60 backdrop-blur-sm border border-[#1E1E1E] rounded-xl px-5 py-3">
            <div className="h-8 px-3 bg-[#3498DB] rounded-lg flex items-center justify-center flex-shrink-0">
              <span className="text-white text-sm font-black tracking-wider" style={{ fontFamily: "'Orbitron', sans-serif" }}>OEM</span>
            </div>
            <div className="text-left">
              <p className="text-white text-xs font-semibold">OEM Auto- &amp; Motoronderdelen</p>
              <p className="text-[#888] text-[10px]">Originele fabrieksonderdelen op kenteken leverbaar</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
